const MODELS_API_URL = '/rest/servicedesk/1/customer/models';

interface requestCountResponse {
	userRequestsCounts: {
		allOpenRequestsCount: number;
		approvalsCount: number;
		pendingApprovalsCount: number;
	};
}

export const getRequestCount = async (
	cloudUrl: string,
	helpCenterAri: string,
): Promise<requestCountResponse> => {
	const response = await fetch(`${cloudUrl}${MODELS_API_URL}`, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
		},
		body: JSON.stringify({
			context: { clientBasePath: cloudUrl, helpCenterAri },
			models: ['userRequestsCounts'],
		}),
	});
	return response.json() as Promise<requestCountResponse>;
};
